import React from 'react';
import styles from './MountainPageSkeleton.module.css';

function MountainPageSkeleton() {
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.contentContainer}>
        <div className={styles.modalBody}>
          {/* Left Column */}
          <div className={styles.modalInfo}>
            <div className={styles.titleRow}>
              {/* Back button placeholder */}
              <div className={styles.skeletonBlock} style={{ width: '80px', height: '24px' }}>
                <div className={styles.shimmer}></div>
              </div>
              {/* Title placeholder */}
              <div className={styles.skeletonBlock} style={{ width: '200px', height: '32px' }}>
                <div className={styles.shimmer}></div>
              </div>
            </div>

            <div className={styles.modalActions}>
              <div className={styles.skeletonBlock} style={{ width: '120px', height: '40px' }}>
                <div className={styles.shimmer}></div>
              </div>
              <div className={styles.skeletonBlock} style={{ width: '120px', height: '40px' }}>
                <div className={styles.shimmer}></div>
              </div>
              <div className={styles.skeletonBlock} style={{ width: '120px', height: '40px' }}>
                <div className={styles.shimmer}></div>
              </div>
            </div>

            <div className={`${styles.skeletonBlock} ${styles.imageGallery}`}>
              <div className={styles.shimmer}></div>
            </div>

            <div className={styles.detailsGrid}>
              {[1, 2, 3, 4, 5, 6].map(i => (
                <div key={i} className={`${styles.skeletonBlock} ${styles.detailItem}`}>
                  <div className={styles.shimmer}></div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className={styles.modalInfo}>
            <div className={`${styles.skeletonBlock} ${styles.textBlock}`} style={{ width: '40%', height: '2rem', marginBottom: '1.5rem' }}><div className={styles.shimmer}></div></div>
            
            <div className={`${styles.skeletonBlock} ${styles.textBlock}`} style={{ width: '90%' }}><div className={styles.shimmer}></div></div>
            <div className={`${styles.skeletonBlock} ${styles.textBlock}`} style={{ width: '95%' }}><div className={styles.shimmer}></div></div>
            <div className={`${styles.skeletonBlock} ${styles.textBlock}`} style={{ width: '85%' }}><div className={styles.shimmer}></div></div>
            <div className={`${styles.skeletonBlock} ${styles.textBlock}`} style={{ width: '90%' }}><div className={styles.shimmer}></div></div>
            
            <div className={`${styles.skeletonBlock} ${styles.mapPlaceholder}`}>
              <div className={styles.shimmer}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MountainPageSkeleton;
